

import { store, persistor } from '../src/redux/store';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import React from 'react';
import { PersistGate } from 'redux-persist/integration/react';
//import { ToastProvider } from 'react-toast-notifications'

// import 'bootstrap/dist/css/bootstrap-theme.css';\
import App from './App';
import ReactDOM from 'react-dom';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

// if (process.env.NODE_ENV !== "development"){
//     console.log = () => {};
// }
// console.log = () => {};

const rootElement = document.getElementById('root');



ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App />
        {/* <Routes>
        <Route path="/" element={ <App /> }>
        </Route>
      </Routes> */}
      </PersistGate>
    </Provider>
  </BrowserRouter>

  , rootElement);
//serviceWorker.unregister();
